import { Observable, of } from "rxjs";
import { BaseFlowComponent } from "../base-flow-component/base-flow-component";
import { DevicesService } from "../../../../services/devices.service";
import { NotificationService } from "../../../../../core/services/notification.service";
import { RequestsService } from "../../../../services/requests.service";
import { Guid } from "guid-typescript";
import { UploadFile } from "../../../../models/attachment";
import { CommentTypeEnum } from "../../../../enums/comment-type.enum";
import { CommentKindEnum } from "../../../../enums/comment-kind.enum";
import { NewCommentModel } from "../../../../models/request/comments/new-comment-model";
import { Component } from "@angular/core";
import { AttachmentType } from "../../../../enums";
import { CompleteActivitySignatureContainerData } from "./complete-activity-signature-container.data";

@Component({
    selector: 'complete-activity-signature-container',
    templateUrl: './complete-activity-signature-container.component.html',
    styleUrls: ['./complete-activity-signature-container.component.scss',
        '../../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
        '../../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss']
})
export class CompleteActivitySignatureContainerComponent 
    extends BaseFlowComponent<CompleteActivitySignatureContainerData>  {
    
    merchantEmailDisabled: boolean;
    private signatureData: string;

    constructor(
        public requestsService: RequestsService,
        public devicesService: DevicesService,
        public notificationService: NotificationService
    ) {
        super();
    }

    initData() {
    }

    saveChanges(): Observable<any> {
        return of({});
    }

    uploadSignature(data: string) {
        this.signatureData = data;
    }

    finishSuccesfully() {
        let file = new UploadFile;
        file.fileName = `confirm-signature_${this.data.requestId}_${this.data.activityId}.jpg`;
        file.fileExtension = '.jpg';
        file.uid = Guid.create().toString();
        file.attachmentTypeIds = [AttachmentType.merchantMemberSignature]
        file.attachmentTypeId = AttachmentType.merchantMemberSignature;
        file.fileData = this.signatureData;
        this.data.signatureData = this.signatureData;
        
        const commentText = !this.merchantEmailDisabled
            ? `Работу принял представитель ТСП ${this.data.merchantMember} (email: <a class="text-white" href="mailto:${this.data.merchantEmail}" target="_blank">${this.data.merchantEmail}</a>)`
            : `Работу принял представитель ТСП ${this.data.merchantMember}`;

        this.requestsService.addCommentWithoutProgress({
            requestId: this.data.requestId,
            activityId: this.data.activityId,
            text: commentText,
            uploadAttachments: [file],
            commentType: CommentTypeEnum.user,
            commentKind: CommentKindEnum.internal
        } as NewCommentModel).subscribe(() => {
            this.dataSaving = false;
            this.goToNext();
        });
    }

    get canSave(): boolean {
        let merchantMemberValid = this.data.merchantMember && this.data.merchantMember.trim() != '';
        let merchantEmailValid = this.merchantEmailDisabled || this.merchantEmailValid();

        return merchantMemberValid && merchantEmailValid && this.signatureData != null;
    }

    changeMerchantEmailDisabled(event: any) {
        if (event.target.checked) {
            this.data.merchantEmail = '';
        }
    }

    merchantEmailValid() {
        const emailRegex = /^[a-zA-Z][a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/;
        let email = this.data.merchantEmail;

        return email != null && email.trim() != '' && emailRegex.test(email);
    }
}